import {
  Store,
  RevCenter,
  Column,
} from "@shared-ui-components/DataTable/types";
import {
  formatNumberWithComma,
  formatNumberWithCommaAndDollar,
} from "@src/constants";
import { getPropertyName } from "@utils/dataTableHelper";

// Functions
export const refineData = (data: Store[] | RevCenter[]) => {
  if (data[0] !== null && data[0] !== undefined) {
    const refined = data?.map((el: any) => {
      const refinedObject = {
        name: getPropertyName(el.property_short_name, el.name),
        revenue: el.revenue,
        cogs: el.cogs,
        qty: el.qty,
        total: el.total,
      };
      return refinedObject;
    });
    return refined;
  }
  return [];
};

// Constants
export const columns: Column[] = [
  { id: "name", label: "Store", minWidth: 102 },
  {
    id: "cogs",
    label: "COGS",
    minWidth: 78,
    align: "left",
    format: (value: number) => {
      return `${value}%`;
    },
  },
  {
    id: "qty",
    label: "QTY",
    minWidth: 100,
    align: "left",
    format: formatNumberWithComma,
  },
  {
    id: "revenue",
    label: "Net Sales",
    minWidth: 102,
    align: "left",
    format: formatNumberWithCommaAndDollar,
  },
];
export const filterOptions = [
  { label: "By Store", value: "store" },
  { label: "By Rev Center", value: "rvc" },
];

export const defaultOptions = [{ label: "By Rev Center", value: "rvc" }];
